import useDocumentBlob from "./use-document-blob";

export default function useThumbnail({
  downloadUrl,
  documentId,
  doctype,
  isSigned = false,
}) {
  const {
    blob: thumbnail,
    error,
    isLoading,
  } = useDocumentBlob({
    downloadUrl,
    documentId,
    doctype,
    params: {
      thumbnail: true,
      signed: isSigned,
    },
  });

  return {
    thumbnail,
    error,
    isLoading,
  };
}
